var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87097 20.5H16.129C18.2677 20.5 20 18.7677 20 16.629V4.37097C20 2.23226 18.2677 0.5 16.129 0.5H3.87097C1.73226 0.5 0 2.23226 0 4.37097V16.629C0 18.7677 1.73226 20.5 3.87097 20.5ZM5.80645 6.30645H2.58065V4.37097C2.58065 3.65806 3.15806 3.08065 3.87097 3.08065H5.80645V6.30645ZM5.80645 8.8871V12.1129H2.58065V8.8871H5.80645ZM5.80645 14.6935V17.9194H3.87097C3.15806 17.9194 2.58065 17.3419 2.58065 16.629V14.6935H5.80645ZM8.3871 12.1129V8.8871H17.4194V12.1129H8.3871ZM16.129 17.9194H8.3871V14.6935H17.4194V16.629C17.4194 17.3419 16.8419 17.9194 16.129 17.9194ZM8.3871 6.30645V3.08065H16.129C16.8419 3.08065 17.4194 3.65806 17.4194 4.37097V6.30645H8.3871Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.1bf0715df150c18cb928d30aaa843728.svg";
export { ForwardRef as ReactComponent };